import script from "./OrderTimeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTimeSettings.vue?vue&type=script&setup=true&lang=js"

import "./OrderTimeSettings.vue?vue&type=style&index=0&id=71a47bbe&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a47bbe"]])

export default __exports__